import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// 创建Vuex对象
const store = new Vuex.Store({
    state: {
        inputData: {
            //  输入框内容
            account: "",
            password: "",
            phone: "",
            sms: "",
        },
        userInfo: {},
        activity: {},
        diceInfo: {},
        AppointInfo: {}
    },
    mutations: {
        // 更新sdk输入框数据
        updatedInput(state, payload) {
            state.inputData = { ...payload }
        },
        // 更新当前手机号下所有的游戏账号
        updatedAllInfo(state, payload) {
            Vue.set(state, 'allUserInfo', payload)
        },
        // 当前选中的角色信息
        updatedUserInfo(state, payload) {
            state.userInfo = Object.assign({}, { ...payload }) 
        },
        // 当前活动存储的参数
        updatedActivity(state, payload) {            
            state.activity = { ...payload }
        },
        // 最新需要执行的参数
        updatedDiceInfo(state, payload) {
            state.diceInfo = { ...payload }
        },
        // 再次执行时候需要返回的参数
        updatedAppointInfo(state, payload) {
            state.AppointInfo = { ...payload }
        },
        // 助力分享请求
        updatedShareInfo(state, payload) {
            state.ShareInfo = { ...payload }
        },
        // 分享给好友
        updatedGetShareInfo(state, payload) {
            state.GetShareInfo = { ...payload }
        }
    },
    actions: {
        setInput({ commit }, payload) {
            commit('updatedInput', payload)
        },
        setAllInfo({ commit }, payload) {
            commit('updatedAllInfo', payload)
        },
        setUserInfo({ commit }, payload) {
            commit('updatedUserInfo', payload)
        },        
        setActivity({ commit }, payload) {
            commit('updatedActivity', payload)
        },        
        setDiceInfo({ commit }, payload) {
            commit('updatedDiceInfo', payload)
        },        
        setAppointInfo({ commit }, payload) {
            commit('updatedAppointInfo', payload)
        },
        setShareInfo({ commit }, payload) {
            commit('updatedShareInfo', payload)
        },
        setGetShareInfo({ commit }, payload) {
            commit('updatedGetShareInfo', payload)
        },
    }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js